export default {
  delete: 'Padam',
  edit: 'Ubah suai',
  cancel: 'Batal',
  clear: 'Kosongkan',
  new: 'Baharu',
  update: 'Kemas kini',
  undo: 'Buat asal',
  option: 'Pilihan',
  details: 'Butiran',
  deleting: 'Memadam',
  createdAt: 'Dicipta Pada',
  firstSeen: 'Pertama Dilihat',
  lastActive: 'Terakhir Aktif',
  'idle.title': 'Sesi anda akan tamat tempoh',
  'idle.content': 'Sambung semula sesi sekarang atau log keluar',
  resume: 'Sambung semula',
  name: 'Nama',
  'success.reloading': 'Berjaya, memuatkan semula halaman',
  'fail.retry': 'Gagal, sila cuba lagi',
  tags: 'Tag',
  after: 'Selepas',
  flow: 'Aliran',
  text: 'Teks',
  image: 'Imej',
  video: 'Video',
  file: 'Fail',
  custom: 'Tersuai',
  input: 'Input',
  quickReplies: 'Balasan Pantas',
  ctaUrl: 'URL CTA',
  button: 'Butang',
  question: 'Soalan',
  fieldRequired: 'Medan ini diperlukan',
  entity: 'Entiti',
  active: 'Aktif',
  inactive: 'Tidak aktif',
  deleted: 'Dipadam',
  next: 'Seterusnya',
  category: 'Kategori',
  portalUser: 'Pengguna Portal',
  role: 'Peranan',
  admin: 'Pentadbir',
  user: 'Pengguna',
  username: 'Nama Pengguna',
  email: 'E-mel',
  firstName: 'Nama Pertama',
  lastName: 'Nama Akhir',
  fullName: 'Nama Penuh',
  resetPassword: 'Set Semula Kata Laluan',
  'resetPassword.emailSent': 'E-mel set semula kata laluan telah dihantar kepada pengguna',
  'resetPassword.confirm.title': 'Set semula kata laluan untuk pengguna ini?',
  'resetPassword.confirm.content':
    'E-mel set semula kata laluan akan dihantar kepada {username} ({email})',
  'resetPassword.emailFailed': 'Gagal menghantar e-mel set semula, sila cuba lagi',
  'resetPassword.tokenExpired': 'Token Set Semula Kata Laluan telah tamat tempoh',
  oldPassword: 'Kata Laluan Semasa',
  newPassword: 'Kata Laluan Baharu',
  'password.characterNotMet':
    'Kata laluan mesti mengandungi sekurang-kurangnya satu huruf, satu nombor dan satu aksara khas',
  confirmPassword: 'Sahkan Kata Laluan',
  'confirmPassword.mismatch': 'Kedua-dua kata laluan yang anda masukkan tidak sepadan!',
  unlock: 'Buka Kunci',
  'portalUser.unlock.title': 'Buka kunci pengguna',
  'portalUser.unlock.content':
    '{username} ({email}) - E-mel set semula kata laluan akan dihantar kepada pengguna jika berkenaan',
  'portalUser.userPasswordModal.title': 'Modal Kata Laluan Pengguna',
  logout: 'Log Keluar',
  dormant: 'Tidak Aktif',
  'portalUser.dormant.title': 'Adakah anda pasti mahu menidakaktifkan pengguna ini?',
  'portalUser.dormant.content':
    '{username} ({email}) - Sila ambil perhatian bahawa selepas dinyahaktifkan, pengguna ini tidak lagi boleh mengakses portal ini',
  reactivate: 'Aktifkan Semula',
  'portalUser.reactivate.title': 'Adakah anda pasti mahu mengaktifkan semula pengguna ini?',
  'portalUser.reactivate.content':
    '{username} ({email}) - Sila ambil perhatian bahawa selepas diaktifkan semula, pengguna ini akan mendapat akses ke portal ini serta-merta',
  'portalUser.delete.title': 'Adakah anda pasti mahu memadam pengguna ini?',
  'portalUser.delete.content':
    '{username} ({email}) - Sila ambil perhatian bahawa selepas dipadam, pengguna ini tidak lagi boleh mengakses portal ini. Data peribadi akan dihapuskan; sebagai alternatif, anda boleh menidakaktifkan pengguna ini.',
  'portalUser.delete.undo': '{username} ({email}) dipadam',
  'portalUser.emailChange.title': 'Tukar e-mel pengguna?',
  'portalUser.emailChange.content':
    'E-mel akan dikemas kini kepada {newEmail} dan e-mel set semula kata laluan akan dihantar ke alamat tersebut. Pengguna akan dilog keluar dan mesti menetapkan kata laluan baharu untuk log masuk semula.',
  'portalUser.emailChange.noEmail.content':
    'E-mel akan dikemas kini kepada {newEmail}. Perkhidmatan e-mel tidak dikonfigurasikan untuk organisasi ini, jadi kata laluan baharu akan dijana dan ditunjukkan kepada anda untuk dikongsi dengan pengguna.',
  platform: 'Platform',
  notes: 'Nota',
  'pages.review.title': 'Semakan',
  'pages.review.description':
    'Jana semakan berstruktur bagi satu atau lebih dokumen berdasarkan Senarai Soalan anda',
  'pages.login.rememberMe': 'Ingat saya',
  'pages.login.forgotPassword': 'Lupa Kata Laluan?',
  'pages.welcome.alertMessage': 'Komponen berat yang lebih pantas dan mantap telah dikeluarkan.',
  'pages.admin.subPage.title': 'Halaman ini hanya boleh dilihat oleh Pentadbir',
  'pages.file.placeholder.type': 'Jenis',
  'pages.file.placeholder.people': 'Pencipta',
  'pages.file.placeholder.search': 'Cari fail atau folder',
  'pages.file.placeholder.editfile': 'Ubah Suai Nama Fail',
  'pages.file.pdf': 'PDF',
  'pages.file.document': 'Dokumen',
  'pages.file.msg': 'MSG',
  'pages.file.eml': 'EML',
  'pages.file.txt': 'Teks',
  'pages.file.md': 'Markdown',
  'pages.file.excel': 'Excel',
  'pages.file.powerpoint': 'PowerPoint',
  'pages.file.uploading': 'Memuat naik',
  'pages.file.clickDragFile': 'Klik atau seret fail ke sini untuk memuat naik',
  'pages.file.createfolder': 'Cipta Folder',
  'pages.file.uploadFiles': 'Muat Naik Fail',
  'pages.file.upload.time': 'Masa Dimuat Naik:',
  'pages.file.created.time': 'Masa Dicipta:',
  'pages.file.favorites': 'Kegemaran Saya',
  'pages.file.history': 'Sejarah Semakan',
  'pages.file.success': 'Berjaya dicipta',
  'pages.file.filePreview': 'Pratonton Fail',
  'pages.file.prompt.uploadFiled': 'Gagal memuat naik',
  'pages.file.prompt.network': 'Ralat Rangkaian',
  'pages.file.prompt.fetchFiles': 'Gagal mendapatkan maklumat senarai fail',
  'pages.file.prompt.createGroup': 'Gagal mencipta kumpulan',
  'pages.file.prompt.createFolderSucc': 'Folder berjaya dicipta',
  'pages.file.prompt.createFolderFail': 'Gagal mencipta folder',
  'pages.file.prompt.updateSucc': 'Berjaya dikemas kini',
  'pages.file.prompt.updateFail': 'Gagal mengemas kini',
  'pages.file.prompt.addFavoriteFail': 'Gagal ditambah',
  'pages.file.prompt.noPermission': 'Anda tiada kebenaran untuk mengubah suai sesi ini',
  'pages.file.prompt.duplicateName': 'Nama sesi berulang',
  'pages.file.prompt.notFound': 'Tidak dapat mencari sesi',
  'pages.file.prompt.deleteGroupSuc': 'Berjaya dipadam',
  'pages.file.prompt.uploadFiles': 'fail sedia untuk dimuat naik',
  'pages.file.prompt.downloadSucc': 'Berjaya dimuat turun',
  'pages.file.prompt.downloadFail': 'Gagal memuat turun',
  'pages.file.prompt.authFail': 'Token kebenaran tiada.',
  'pages.file.prompt.moveSucc': 'Fail berjaya dialihkan',
  'pages.chat.newWithUploadedDocument': 'Sembang Baharu Dengan Dokumen',
  'pages.chat.editSessionName': 'Ubah Suai Nama Sesi',
  'pages.chat.placeholder.inputSessionName': 'Masukkan nama sesi baharu',
  'pages.chat.placeholder': 'Tulis sesuatu yang anda ingin tanya...',
  'pages.chat.word': '/10000 aksara',
  'pages.chat.rateMessage.successfulLike': 'Berjaya menyukai mesej ini',
  'pages.chat.rateMessage.successfulDislike': 'Berjaya tidak menyukai mesej ini',
  'pages.chat.actions.like': 'Respons baik',
  'pages.chat.actions.dislike': 'Respons buruk',
  'pages.chat.rateMessage.error': 'Gagal menilai mesej',
  'pages.chat.selectContext.setFilePriority.success': 'Berjaya mengemas kini Keutamaan Fail',
  'pages.chat.selectContext.setFilePriority.error': 'Ralat semasa mengemas kini Keutamaan Fail',
  'pages.chat.selectContext.toolTipDefault':
    'Secara lalai, bot akan mempunyai akses kepada semua fail yang boleh anda akses.',
  'pages.chat.rerank':
    'Mengisih semula hasil carian sekali lagi sebelum memulangkan keputusan. Ini mungkin meningkatkan kualiti keputusan tetapi menjadikan carian jauh lebih perlahan.',
  'pages.chat.selectContext.tootlTipRestrict':
    'Anda boleh menggunakan menu ini untuk mengehadkan fail yang disediakan kepada model.',
  'pages.chat.hybridSearchAlphaTooltip':
    'Nisbah carian mengawal keseimbangan antara carian semantik dan kata kunci. Nilai rendah memihak kepada carian kata kunci manakala nilai tinggi memihak kepada carian semantik.',
  'pages.chat.favoriteFileWeight':
    'Pemberat ini meningkatkan kedudukan carian fail kegemaran secara buatan.',
  'pages.dashboard.realTimeUsersTitleTooltip':
    'Bilangan pengguna yang sedang berinteraksi dengan bot atau telah berinteraksi dengan bot dalam tempoh 5 minit yang lalu.',
  'pages.dashboard.activeUsersTitleTooltip':
    'Bilangan pengguna yang telah berinteraksi dengan bot dalam tempoh yang dipilih.',
  'pages.dashboard.newUsersTitleTooltip':
    'Bilangan pengguna yang berinteraksi dengan bot buat kali pertama dalam tempoh yang dipilih.',
  'pages.dashboard.promptTokensTitleTooltip':
    'Bilangan token input yang diproses dalam tempoh yang dipilih.',
  'pages.dashboard.completionTokensTitleTooltip':
    'Bilangan token output yang dijana dalam tempoh yang dipilih.',
  'pages.dashboard.userMessagesTitleTooltip':
    'Bilangan mesej yang dihantar oleh pengguna dalam tempoh yang dipilih.',
  'pages.dashboard.storyboardsTitleTooltip':
    'Bilangan mesej pengguna yang dikendalikan oleh papan cerita chatbot pra-bina dalam tempoh yang dipilih.',
  'pages.dashboard.botMessagesTitleTooltip':
    'Bilangan mesej yang dihantar kepada pengguna oleh bot dalam tempoh yang dipilih.',
  'pages.dashboard.broadcastsTitleTooltip':
    'Bilangan mesej yang dihantar kepada pengguna yang dimulakan oleh bot melalui fungsi Siaran dalam tempoh yang dipilih.',
  'pages.dashboard.repliesTitleTooltip':
    'Bilangan mesej yang dihantar kepada pengguna sebagai balasan kepada mesej pengguna dalam tempoh yang dipilih.',
  'pages.dashboard.messageExchangesTitleTooltip':
    'Bilangan pertukaran mesej antara pengguna dan bot dalam tempoh yang dipilih.',
  'pages.dashboard.broadcastTitleTooltip':
    'Bilangan siaran yang dimulakan oleh bot dalam tempoh yang dipilih.',
  'pages.dashboard.outReachTitleTooltip':
    'Jumlah bilangan penerima bagi semua siaran dalam tempoh yang dipilih.',
  'pages.chat.stopGenerating': 'Penjanaan dihentikan.',
  'pages.chat.stopGenerating.error': 'Gagal menghentikan penjanaan.',
  'pages.app.timeline': 'Garis Masa',
  'pages.app.guided_summary': 'Ringkasan Berpandu',
  'pages.app.standard_info': 'Maklumat Pantas',
  'pages.app.addCustomFieldsTitle': 'Tambah medan tersuai untuk diekstrak bagi setiap peristiwa',
  'pages.app.addCustomStepButton': 'Tambah Langkah Tersuai',
  'pages.app.addFieldButton': 'Tambah Medan',
  'pages.app.addFromLibraryButton': 'Tambah daripada Pustaka',
  'pages.app.addToMattersButton': 'Tambah ke Perkara',
  'pages.app.analysisType.agenticResearch.description':
    'Meneroka dokumen yang dipilih dan fail yang dimuat naik, kemudian mensintesis jawapan menyeluruh dengan petikan.',
  'pages.app.analysisType.agenticResearch.title': 'Penyelidikan Agentik',
  'pages.app.analysisType.comparison.description':
    'Membandingkan dua dokumen dan memberikan laporan yang menerangkan perbezaannya. Anda boleh memberikan gesaan untuk menyasarkan perbandingan tersebut.',
  'pages.app.analysisType.comparison.title': 'Perbandingan',
  'pages.app.analysisType.contractDeadlines.description':
    "Senaraikan semua tarikh akhir, tarikh penting dan tempoh yang ditemui dalam kontrak/dokumen. Ia membantu untuk memberikan butiran klien (seperti 'klien ialah bank Singapura yang pakar dalam perkhidmatan e-perbankan')",
  'pages.app.analysisType.contractDeadlines.title': 'Ekstrak Tarikh Akhir',
  'pages.app.analysisType.executiveSummary.description':
    'Menyediakan ringkasan eksekutif yang padat tentang nasihat, isu, risiko dan tindakan utama.',
  'pages.app.analysisType.executiveSummary.title': 'Ringkasan Eksekutif',
  'pages.app.analysisType.gartnerReport.description':
    'Menyediakan laporan industri yang mendalam dengan ramalan dan cadangan.',
  'pages.app.analysisType.gartnerReport.title': 'Laporan Gaya Gartner',
  'pages.app.analysisType.guidedSummary.description':
    'Menyediakan ringkasan terperinci bagi satu dokumen yang dipandu oleh gesaan.',
  'pages.app.analysisType.multiStepPrompt.description':
    'Laksanakan berbilang gesaan secara berturutan, membina di atas output setiap langkah.',
  'pages.app.analysisType.multiStepPrompt.title': 'Gesaan Berbilang Langkah',
  'pages.app.analysisType.scopeOfWork.description':
    'Muat naik atau pilih e-mel, surat atau RFP klien yang mengandungi permintaan untuk bantuan atau perkhidmatan. Dalam "Gesaan", ia membantu untuk memberikan butiran klien (seperti \'klien ialah bank Singapura yang pakar dalam perkhidmatan e-perbankan\')',
  'pages.app.analysisType.scopeOfWork.title': 'Ringkasan Skop Kerja',
  'pages.app.analysisType.standardInfo.description':
    'Menyediakan ringkasan padat, senarai orang dan entiti yang berkaitan serta garis masa peristiwa yang ringkas. Anda boleh menyediakan sehingga 100 dokumen.',
  'pages.app.analysisType.timeline.description':
    'Menyediakan garis masa peristiwa yang terperinci merentasi sehingga 100 dokumen.',
  'pages.app.analyzingFiles': 'Menganalisis fail...',
  'pages.app.applicablePartiesColumnTitle': 'Pihak Berkenaan',
  'pages.app.appsInstructions':
    'Pilih beberapa fail untuk digunakan, kemudian pilih jenis analisis daripada senarai di bawah. Permintaan mengambil masa sekitar 1-5 minit untuk diproses.',
  'pages.app.appsList.agenticResearch.description':
    'Meneroka dokumen yang dipilih dan fail yang dimuat naik, kemudian mensintesis jawapan menyeluruh dengan petikan.',
  'pages.app.appsList.contractDeadlines.description':
    'Senaraikan semua tarikh akhir, tarikh penting dan tempoh yang ditemui dalam kontrak/dokumen.',
  'pages.app.appsList.executiveSummary.description':
    'Gambaran keseluruhan peringkat tinggi tentang perkara utama, penemuan dan cadangan untuk pihak pengurusan',
  'pages.app.appsList.gartnerReport.description':
    'Analisis industri yang mendalam menggunakan metodologi penyelidikan yang yakin dan objektif',
  'pages.app.appsList.guidedSummary.description':
    'Menyediakan ringkasan terperinci bagi satu dokumen yang dipandu oleh gesaan',
  'pages.app.appsList.multiStepPrompt.description':
    'Laksanakan berbilang gesaan secara berturutan, membina di atas output setiap langkah',
  'pages.app.appsList.scopeOfWork.description':
    'Muat naik atau pilih e-mel, surat atau RFP klien yang mengandungi permintaan untuk bantuan atau perkhidmatan.',
  'pages.app.appsList.standardInfo.description':
    'Menyediakan ringkasan padat, senarai orang dan entiti, serta garis masa yang ringkas',
  'pages.app.appsList.timeline.description':
    'Menyediakan garis masa peristiwa yang terperinci merentasi sehingga 100 dokumen',
  'pages.app.appsTitle': 'Aplikasi',
  'pages.app.backgroundColumnTitle': 'Latar Belakang',
  'pages.app.buildMultiStepPromptTitle': 'Bina gesaan berbilang langkah anda',
  'pages.app.clauseColumnTitle': 'Klausa',
  'pages.app.clientDetailsPlaceholder': 'Nama dan butiran ringkas klien',
  'pages.app.clientInformationTitle': 'Maklumat Klien',
  'pages.app.clientLabel': 'Klien',
  'pages.app.collapseAllPrompts': 'Kuncupkan semua gesaan',
  'pages.app.collapsePrompt': 'Kuncupkan gesaan',
  'pages.app.compilingFinalSummary': 'Menyusun ringkasan akhir...',
  'pages.app.complexityLabel': 'Kerumitan',
  'pages.app.configNameLabel': 'Nama Konfigurasi',
  'pages.app.configurationDeletedSuccess': 'Konfigurasi dipadam',
  'pages.app.configurationSavedSuccess': 'Konfigurasi berjaya disimpan',
  'pages.app.configurationUpdatedSuccess': 'Konfigurasi berjaya dikemas kini',
  'pages.app.contactLabel': 'Hubungan',
  'pages.app.counterpartyLabel': 'Pihak Bertentangan',
  'pages.app.dateReferenceColumnTitle': 'Tarikh/Rujukan',
  'pages.app.deadlinesSectionTitle': 'Tarikh Akhir',
  'pages.app.deleteConfigConfirmTitle': 'Adakah anda pasti mahu memadam konfigurasi ini?',
  'pages.app.deleteStepTooltip': 'Padam langkah',
  'pages.app.detailsColumnTitle': 'Butiran',
  'pages.app.doneCount': 'Selesai ({completed}/{total})',
  'pages.app.dragHereToUpload': 'Seret ke sini untuk memuat naik',
  'pages.app.dragStepTooltip': 'Seret langkah',
  'pages.app.dropZoneForNamedStep': 'Zon lepas untuk {stepName}',
  'pages.app.dropZoneForStepNumber': 'Zon lepas untuk langkah {stepNumber}',
  'pages.app.durationColumnTitle': 'Tempoh',
  'pages.app.enterConfigNamePlaceholder': 'Masukkan nama konfigurasi',
  'pages.app.enterDescriptionPlaceholder': 'Masukkan penerangan',
  'pages.app.entitiesColumnTitle': 'Entiti',
  'pages.app.expandAllPrompts': 'Kembangkan semua gesaan',
  'pages.app.expandPrompt': 'Kembangkan gesaan',
  'pages.app.extendPromptTabLabel': 'Lanjutkan Gesaan',
  'pages.app.extraFieldDescriptionPlaceholder':
    'Penerangan (cth. Ekstrak nilai kewangan yang disebut)',
  'pages.app.extraFieldKeyPlaceholder': 'Kunci (cth. Bajet)',
  'pages.app.extractColumnTitle': 'Ekstrak',
  'pages.app.extractDeadlinesModalDescription':
    "Senaraikan semua tarikh akhir, tarikh penting dan tempoh yang ditemui dalam kontrak/dokumen. Ia membantu untuk memberikan butiran klien (seperti 'klien ialah bank Singapura yang pakar dalam perkhidmatan e-perbankan')",
  'pages.app.fileCountLabel': '{count} Fail',
  'pages.app.filesCompleteCount': '{completed}/{total} fail selesai',
  'pages.app.hardDeadlineColumnTitle': 'Tarikh Akhir Mutlak',
  'pages.app.inProgressSuffix': ' (sedang berjalan)',
  'pages.app.keyDatesDeadlinesTitle': 'Tarikh Penting & Tarikh Akhir',
  'pages.app.loadSavedConfigPlaceholder': 'Muatkan konfigurasi tersimpan',
  'pages.app.loadingDocumentTip': 'Memuatkan dokumen...',
  'pages.app.mattersUpdatedSuccess': 'Perkara berjaya dikemas kini',
  'pages.app.moveStepDownTooltip': 'Alih ke bawah',
  'pages.app.moveStepUpTooltip': 'Alih ke atas',
  'pages.app.newAnalysisModesDescription':
    'Kami telah memperkenalkan dua mod analisis baharu yang berkuasa untuk membantu anda memperoleh lebih banyak nilai daripada kontrak anda.',
  'pages.app.newAnalysisModesTitle': 'Mod Analisis Baharu',
  'pages.app.newFieldDefaultKey': 'Medan {number}',
  'pages.app.newSessionLabel': 'Sesi Baharu',
  'pages.app.newStepDefaultName': 'Langkah Baharu',
  'pages.app.noSourceDocumentsDescription': 'Tiada dokumen sumber',
  'pages.app.noTimelineItemsExtracted': 'Tiada item garis masa diekstrak.',
  'pages.app.overallTabLabel': 'Keseluruhan',
  'pages.app.overviewSectionTitle': 'Gambaran Keseluruhan',
  'pages.app.partiesSectionTitle': 'Pihak',
  'pages.app.peopleEntitiesInvolvedLabel': 'Orang / Entiti Yang Terlibat',
  'pages.app.periodsDurationsTitle': 'Tempoh & Jangka Masa',
  'pages.app.pleaseEnterPlaceholder': 'Sila masukkan',
  'pages.app.processingNextStep': 'Memproses langkah seterusnya...',
  'pages.app.promptForStepPlaceholder': 'Gesaan untuk langkah ini',
  'pages.app.promptLabelWithValue': 'Gesaan: {prompt}',
  'pages.app.provideDetailsTabLabel': 'Berikan butiran',
  'pages.app.provideDocumentsTabLabel': 'Berikan dokumen',
  'pages.app.providePromptsTabLabel': 'Berikan gesaan',
  'pages.app.provisionColumnTitle': 'Peruntukan',
  'pages.app.publishAudienceGroupsLabel': 'Kumpulan',
  'pages.app.publishAudienceLabel': 'Khalayak',
  'pages.app.publishAudienceOptionFirmWide': 'Seluruh Firma',
  'pages.app.publishAudienceOptionGroup': 'Kumpulan',
  'pages.app.publishAudienceOptionPublic': 'Awam',
  'pages.app.publishButton': 'Terbitkan',
  'pages.app.publishConfigTitle': 'Terbitkan Konfigurasi',
  'pages.app.publishFirmWideNotice':
    'Konfigurasi ini akan dikongsi dengan semua orang dalam organisasi anda. Permintaan akan dihantar kepada pentadbir organisasi untuk kelulusan.',
  'pages.app.publishPublicNotice':
    'Konfigurasi ini akan kelihatan kepada semua pengguna. Permintaan akan dihantar kepada super admin untuk kelulusan.',
  'pages.app.publishRequestSubmitted':
    'Permintaan penerbitan dihantar — menunggu kelulusan pentadbir',
  'pages.app.publishedToGroup': 'Diterbitkan kepada kumpulan',
  'pages.app.readingDocumentName': 'Membaca {name}',
  'pages.app.restrictionColumnTitle': 'Sekatan',
  'pages.app.restrictiveCovenantsTitle': 'Perjanjian Sekatan',
  'pages.app.reuseButton': 'Guna semula',
  'pages.app.runAppButton': 'Jalankan Aplikasi',
  'pages.app.sanitizedCheckingDocuments': 'Menyemak dokumen…',
  'pages.app.sanitizedSearchingDocuments': 'Mencari dokumen…',
  'pages.app.sanitizedWorkingThroughDocuments': 'Meneliti dokumen…',
  'pages.app.saveConfigButton': 'Simpan Konfigurasi',
  'pages.app.saveConfigurationTitle': 'Simpan Konfigurasi',
  'pages.app.scopeOfWorkModalDescription':
    'Muat naik atau pilih e-mel, surat atau RFP klien yang mengandungi permintaan untuk bantuan atau perkhidmatan. Dalam "Gesaan", ia membantu untuk memberikan butiran klien (seperti \'klien ialah bank Singapura yang pakar dalam perkhidmatan e-perbankan\')',
  'pages.app.searchMattersPlaceholder': 'Cari perkara...',
  'pages.app.searchPromptsPlaceholder': 'Cari gesaan...',
  'pages.app.selectAtLeastOneGroupError': 'Pilih sekurang-kurangnya satu kumpulan',
  'pages.app.selectDocumentsStepTitle': '1. Pilih dokumen yang ingin anda analisis',
  'pages.app.selectMattersLabel': 'Pilih perkara:',
  'pages.app.sharedConfigLabel': '{name} (dikongsi)',
  'pages.app.sourcesColumnTitle': 'Sumber',
  'pages.app.specialRequestsSectionTitle': 'Permintaan Khas',
  'pages.app.specificInformationStepTitle': '2. Maklumat khusus (pilihan)',
  'pages.app.stepNamePlaceholder': 'Nama Langkah (cth. Ekstrak Entiti)',
  'pages.app.stepNumberLabel': 'Langkah {number}',
  'pages.app.subagentLabel': 'Subejen {number}',
  'pages.app.subjectLabel': 'Perkara',
  'pages.app.summaryLabel': 'Ringkasan',
  'pages.app.timelineFieldsDescription':
    'Tentukan lajur tambahan yang anda mahu lihat dalam garis masa. Bagi setiap medan, berikan kunci (tajuk lajur) dan penerangan tentang maklumat yang perlu diekstrak.',
  'pages.app.tool.checkingDocuments': 'Menyemak dokumen',
  'pages.app.tool.readingDocument': 'Membaca dokumen',
  'pages.app.tool.searchingDocuments': 'Mencari dokumen',
  'pages.app.tool.workingWithName': 'Sedang bekerja ({name})',
  'pages.app.tool.writingReport': 'Menulis laporan',
  'pages.app.untitledSession': '(Tanpa Tajuk)',
  'pages.app.updateConfigButton': 'Kemas kini',
  'pages.app.updateConfigurationTitle': 'Kemas Kini Konfigurasi',
  'pages.app.updateMattersFailed': 'Gagal mengemas kini perkara',
  'pages.app.uploadOrSelectFilesError': 'Sila muat naik fail atau pilih fail sedia ada',
  'pages.app.urgencyColumnTitle': 'Kesegeraan',
  'pages.app.useAnotherAppButton': 'Guna Aplikasi lain',
  'pages.app.whatsNew': 'Apa yang Baharu',
  'pages.app.workingEllipsis': 'Sedang bekerja…',
  'pages.app.workingThroughDocumentsCount': 'Meneliti dokumen ({completed}/{total})',
  'pages.login.microsoftSSO': 'Log masuk dengan Microsoft',
  'pages.login.loading': 'Memuatkan...',
  'pages.login.redirectingToMS': 'Mengalihkan ke Microsoft SSO...',
  'pages.loggedOut.title': 'Telah log keluar',
  'pages.loggedOut.heading': 'Anda telah dilog keluar',
  'pages.loggedOut.description':
    'Anda boleh menutup tetingkap ini atau kembali ke halaman log masuk untuk log masuk semula.',
  'pages.loggedOut.return': 'Kembali ke log masuk',
  'pages.projectsHub.func.chat': 'Sembang',
  'pages.projectsHub.func.scribe': 'Scribe',
  'pages.projectsHub.func.apps': 'Aplikasi',
  'pages.projectsHub.func.review': 'Semakan',
  'pages.projectsHub.func.sideBySide': 'Bersebelahan',
  'pages.projectsHub.func.comparison': 'Perbandingan',
  'pages.projectsHub.func.translation': 'Terjemahan',
  'pages.projectsHub.func.template': 'Output Tersuai',
  'pages.projectsHub.func.quote': 'Sebut Harga',
  'pages.projectsHub.untitledSession': 'Tanpa Tajuk',
  'pages.projectsHub.untitledFileLabel': '(Tanpa Tajuk)',
  'pages.projectsHub.errors.loadDataFailed': 'Gagal memuatkan data',
  'pages.projectsHub.subfolderCreated': 'Subfolder dicipta',
  'pages.projectsHub.collectionCreated': 'Koleksi dicipta',
  'pages.projectsHub.errors.createFailed': 'Gagal mencipta',
  'pages.projectsHub.errors.updateFailed': 'Gagal mengemas kini',
  'pages.projectsHub.deleteCollectionConfirm.title': 'Padam Koleksi',
  'pages.projectsHub.deleteCollectionConfirm.content': 'Padam "{name}"?',
  'pages.projectsHub.collectionDeleted': 'Dipadam',
  'pages.projectsHub.errors.deleteFailed': 'Gagal',
  'pages.projectsHub.sessionsAdded': '{count} sesi ditambah',
  'pages.projectsHub.errors.addSessionsFailed': 'Gagal menambah',
  'pages.projectsHub.sessionRemoved': 'Sesi dibuang',
  'pages.projectsHub.errors.removeSessionFailed': 'Gagal membuang sesi',
  'pages.projectsHub.sessionsRemoved': '{count} sesi dibuang',
  'pages.projectsHub.errors.removeSessionsFailed': 'Gagal membuang sesi',
  'pages.projectsHub.fieldSaved': 'Disimpan',
  'pages.projectsHub.errors.saveFieldFailed': 'Gagal menyimpan',
  'pages.projectsHub.folderDeleted': 'Folder dipadam',
  'pages.projectsHub.errors.deleteFolderFailed': 'Gagal memadam folder',
  'pages.projectsHub.folderCreated': 'Folder dicipta',
  'pages.projectsHub.errors.createFolderFailed': 'Gagal mencipta folder',
  'pages.projectsHub.deleteFolderConfirm.description': 'Padam "{name}" dan semua kandungannya?',
  'pages.projectsHub.deleteSessionsConfirm.title': 'Padam Sesi',
  'pages.projectsHub.deleteSessionsConfirm.description': 'Buang {count} sesi daripada koleksi ini?',
  'pages.projectsHub.removeSessionConfirm.title': 'Buang Sesi',
  'pages.projectsHub.removeSessionConfirm.description': 'Buang "{name}" daripada koleksi ini?',
  'pages.projectsHub.sort.newestFirst': 'Terbaharu dahulu',
  'pages.projectsHub.sort.oldestFirst': 'Terlama dahulu',
  'pages.projectsHub.sort.nameAsc': 'Nama (A-Z)',
  'pages.projectsHub.sort.nameDesc': 'Nama (Z-A)',
  'pages.projectsHub.doubleClickToOpen': 'Klik dua kali untuk membuka',
  'pages.projectsHub.tidyUp': 'Kemaskan',
  'pages.projectsHub.exit': 'Keluar',
  'pages.projectsHub.manage': 'Urus',
  'pages.projectsHub.deleteSessionsButton': 'Padam ({count})',
  'pages.projectsHub.searchSessionsPlaceholder': 'Cari sesi',
  'pages.projectsHub.emptyState.noFiles': 'Tiada fail',
  'pages.projectsHub.newFolderButton': 'Folder Baharu',
  'pages.projectsHub.addSessionsButton': 'Tambah Sesi',
  'pages.projectsHub.folderInfoLabel': 'Maklumat Folder',
  'pages.projectsHub.mattersHeading': 'Perkara',
  'pages.projectsHub.mattersSubtitle':
    'Cipta koleksi dan susun sesi daripada fungsi berbeza dalam satu ruang kerja.',
  'pages.projectsHub.hubBreadcrumbLabel': 'Hab',
  'pages.projectsHub.deleteFolderButton': 'Padam Folder',
  'pages.projectsHub.itemsLabel': 'Item',
  'pages.projectsHub.selectSubfolderEmptyState': 'Pilih subfolder untuk melihat butiran',
  'pages.projectsHub.selectFolderEmptyState': 'Pilih folder untuk melihat butiran',
  'pages.projectsHub.noCollectionsMatch': 'Tiada koleksi sepadan dengan penapis semasa anda.',
  'pages.projectsHub.noSessionsFoundForFunction': 'Tiada sesi {func} ditemui.',
  'pages.projectsHub.addSelectedSessionsButton':
    'Tambah {count, plural, =0 {yang dipilih} other {# sesi}}',
  'pages.projectsHub.step1ChooseFunctionType': 'Langkah 1 — Pilih jenis fungsi',
  'pages.projectsHub.selectFunctionPlaceholder': 'Pilih fungsi',
  'pages.projectsHub.step2SelectSessions': 'Langkah 2 — Pilih sesi untuk ditambah',
  'pages.projectsHub.createFolderButton': 'Cipta Folder',
  'pages.projectsHub.folderNameLabel': 'Nama folder',
  'pages.projectsHub.subfolderNamePlaceholder': 'cth. Usaha Wajar',
  'pages.projectsHub.collectionNamePlaceholder': 'cth. Usaha Wajar M&A',
  'pages.projectsHub.optionalDescriptionPlaceholder': 'Penerangan pilihan',
  'pages.projectsHub.optionalNotesPlaceholder': 'Nota pilihan',
  'pages.projectsHub.createCollectionModalTitle': 'Cipta Koleksi',
  'pages.projectsHub.collectionNameLabel': 'Nama koleksi',
  'pages.projectsHub.editCollectionModalTitle': 'Sunting • {name}',
  'pages.projectsHub.itemCountLabel': '{count, plural, one {# item} other {# item}}',
  'pages.projectsHub.fileCountLabel': '{count, plural, one {# fail} other {# fail}}',
  'pages.sideBySide.addAtLeastOneQuestion': 'Sila tambah sekurang-kurangnya satu soalan',
  'pages.sideBySide.addAtLeastOneQuestionBeforeSubmitting':
    'Sila tambah sekurang-kurangnya satu soalan sebelum menghantar.',
  'pages.sideBySide.addNewQuestionsPlaceholder': 'Tambah soalan baharu (satu setiap baris)',
  'pages.sideBySide.addPlusButton': 'Tambah +',
  'pages.sideBySide.addQuestionsLabel': 'Tambah Soalan',
  'pages.sideBySide.addToMattersButton': 'Tambah ke Perkara',
  'pages.sideBySide.authorFieldLabel': 'Penulis',
  'pages.sideBySide.authorLabel': 'Penulis: ',
  'pages.sideBySide.categoryLabel': 'Kategori',
  'pages.sideBySide.cellDetails.answer': 'Jawapan',
  'pages.sideBySide.cellDetails.verified': 'Disahkan',
  'pages.sideBySide.cellDetails.verify': 'Sahkan',
  'pages.sideBySide.cellMarkedUnverified': 'Sel ditandakan sebagai belum disahkan',
  'pages.sideBySide.cellMarkedVerified': 'Sel ditandakan sebagai disahkan',
  'pages.sideBySide.cellUpdatedSuccess': 'Sel berjaya dikemas kini',
  'pages.sideBySide.changesUndone': 'Perubahan dibatalkan',
  'pages.sideBySide.clickOrDragToUpload': 'Klik atau seret untuk memuat naik',
  'pages.sideBySide.cloneButton': 'Klon',
  'pages.sideBySide.cloneModeLabel': 'Klon',
  'pages.sideBySide.clonedNamePrefix': 'DIKLON - {name}',
  'pages.sideBySide.columnEditModal.columnAddedSuccess':
    'Lajur baharu ditambah. Matriks akan dimuat semula sebentar lagi.',
  'pages.sideBySide.columnEditModal.columnUpdateStartedSuccess':
    'Kemas kini lajur dimulakan. Lajur akan dimuat semula sebentar lagi.',
  'pages.sideBySide.columnEditModal.enterPromptWarning': 'Sila masukkan gesaan.',
  'pages.sideBySide.columnEditModal.promptLabel': 'Gesaan',
  'pages.sideBySide.columnEditModal.promptPlaceholder':
    'Terangkan gesaan/arahan sistem untuk lajur ini',
  'pages.sideBySide.columnEditModal.title': 'Ubah Suai Lajur',
  'pages.sideBySide.columnEditModal.updateColumnFailed': 'Gagal mengemas kini lajur',
  'pages.sideBySide.createCustomQuestionListDescription':
    'Cipta senarai soalan Bersebelahan tersuai untuk sesi ini',
  'pages.sideBySide.createModeLabel': 'Cipta',
  'pages.sideBySide.createQuestionListButton': 'Cipta Senarai Soalan',
  'pages.sideBySide.createdByLabel': 'Dicipta oleh: ',
  'pages.sideBySide.createdByYou': 'Anda',
  'pages.sideBySide.customInstructionOptional': '2. Arahan Tersuai (pilihan)',
  'pages.sideBySide.deleteQuestionListConfirm':
    'Adakah anda pasti mahu memadam senarai soalan ini?',
  'pages.sideBySide.dragHereToUpload': 'Seret ke sini untuk memuat naik',
  'pages.sideBySide.emailButton': 'E-mel',
  'pages.sideBySide.exitButton': 'Keluar',
  'pages.sideBySide.exitModeButton': 'Keluar {mode}',
  'pages.sideBySide.fileCount': '{count} Fail',
  'pages.sideBySide.firmOption': 'Firma',
  'pages.sideBySide.firmWideOption': 'Seluruh Firma',
  'pages.sideBySide.fromDocumentOption': 'Daripada Dokumen',
  'pages.sideBySide.groupOption': 'Kumpulan',
  'pages.sideBySide.leadRowHeader': 'Perenggan Dokumen Sumber',
  'pages.sideBySide.manualCraftOption': 'Bina Manual',
  'pages.sideBySide.modifyButton': 'Ubah Suai',
  'pages.sideBySide.modifyModeLabel': 'Ubah Suai',
  'pages.sideBySide.newCategoryPlaceholder': 'Kategori baharu',
  'pages.sideBySide.newQuestionListButtonLabel': 'Senarai Soalan Bersebelahan Baharu',
  'pages.sideBySide.newQuestionListDefaultName': 'Senarai Soalan Bersebelahan Baharu',
  'pages.sideBySide.noNotesAvailable': 'Tiada nota tersedia.',
  'pages.sideBySide.noPurposeAvailable': 'Tiada tujuan tersedia.',
  'pages.sideBySide.noSystemPromptConfigured': 'Tiada gesaan sistem dikonfigurasikan.',
  'pages.sideBySide.notesFieldLabel': 'Nota',
  'pages.sideBySide.notesLabel': 'Nota: ',
  'pages.sideBySide.pendingApprovalTag': 'Menunggu Kelulusan',
  'pages.sideBySide.pollingTimeoutWarning':
    'Tamat masa tinjauan. Perbandingan bersebelahan mungkin masih diproses.',
  'pages.sideBySide.processing': 'Memproses',
  'pages.sideBySide.processingStopped': 'Pemprosesan dihentikan.',
  'pages.sideBySide.publicOption': 'Awam',
  'pages.sideBySide.publishButton': 'Terbitkan',
  'pages.sideBySide.publishQuestionListFailed': 'Gagal menerbitkan senarai soalan',
  'pages.sideBySide.publishStatusLabel': 'Status Penerbitan',
  'pages.sideBySide.publishToLabel': 'Terbitkan kepada:',
  'pages.sideBySide.publishedToAccess': 'Diterbitkan kepada {access}',
  'pages.sideBySide.publishedToGroupSuccess': 'Senarai soalan diterbitkan kepada kumpulan',
  'pages.sideBySide.publishedToPrivateGroups':
    'Senarai soalan diterbitkan kepada kumpulan persendirian',
  'pages.sideBySide.publisherLabel': 'Penerbit: ',
  'pages.sideBySide.purposeFieldLabel': 'Tujuan',
  'pages.sideBySide.purposeLabel': 'Tujuan: ',
  'pages.sideBySide.questionListClonedSuccess': 'Senarai soalan berjaya diklon',
  'pages.sideBySide.questionListCreatedSuccess': 'Senarai soalan berjaya dicipta',
  'pages.sideBySide.questionListDeletedSuccess': 'Senarai soalan berjaya dipadam',
  'pages.sideBySide.questionListNamePlaceholder': 'Nama Senarai Soalan Bersebelahan',
  'pages.sideBySide.questionListUpdatedSuccess': 'Senarai soalan berjaya dikemas kini',
  'pages.sideBySide.questionsListLabel': 'Senarai Soalan',
  'pages.sideBySide.quickQuestionsDescription':
    'Jana perbandingan bersebelahan berstruktur bagi satu atau lebih dokumen berdasarkan set soalan ad-hoc',
  'pages.sideBySide.quickQuestionsTitle': 'Soalan Pantas',
  'pages.sideBySide.rejectedTag': 'Ditolak',
  'pages.sideBySide.restoreConfigurationFailed': 'Gagal memulihkan konfigurasi. Sila cuba lagi.',
  'pages.sideBySide.reuseButton': 'Guna semula',
  'pages.sideBySide.reviewTemplateQuestionsDescription': 'Semak soalan untuk templat ini',
  'pages.sideBySide.saveChangesButton': 'Simpan Perubahan',
  'pages.sideBySide.selectDocumentDescription':
    'Pilih dokumen yang anda ingin buat perbandingan Bersebelahan',
  'pages.sideBySide.selectGroupsPlaceholder': 'Pilih kumpulan',
  'pages.sideBySide.selectGroupsToShareDescription':
    'Pilih satu atau lebih kumpulan untuk dikongsi:',
  'pages.sideBySide.selectionDescription':
    'Jana perbandingan bersebelahan berstruktur bagi satu atau lebih dokumen berdasarkan Senarai Soalan anda',
  'pages.sideBySide.selectionFeatureName': 'bersebelahan',
  'pages.sideBySide.selectionTitle': 'Bersebelahan',
  'pages.sideBySide.sentForApprovalSuccess': 'Senarai soalan dihantar untuk kelulusan',
  'pages.sideBySide.showQuestionsButton': 'Tunjukkan Soalan',
  'pages.sideBySide.startGenerateReview': 'Mula menjana semakan',
  'pages.sideBySide.startNewSideBySideButton': 'Mulakan Bersebelahan baharu',
  'pages.sideBySide.stayButton': 'Kekal',
  'pages.sideBySide.submitFailed': 'Gagal menghantar bersebelahan',
  'pages.sideBySide.systemPromptLabel': 'Gesaan Sistem',
  'pages.sideBySide.tabs.prompts': 'Gesaan',
  'pages.sideBySide.tabs.questionList': 'Senarai Soalan',
  'pages.sideBySide.tabs.selectDocuments': 'Pilih Dokumen',
  'pages.sideBySide.targetAudiencePlaceholder': 'nama klien atau khalayak sasaran',
  'pages.sideBySide.teamsButton': 'Teams',
  'pages.sideBySide.templateSystemPromptLabel': 'Gesaan Sistem Templat',
  'pages.sideBySide.tour.noHistorySessions':
    'Tiada sesi bersebelahan tersedia dalam sejarah. Sila cipta satu terlebih dahulu untuk melihat langkah ini.',
  'pages.sideBySide.tour.step1.description':
    'Mulakan dengan memilih senarai soalan daripada kategori yang tersedia. Klik mana-mana kad senarai soalan untuk meneruskan.',
  'pages.sideBySide.tour.step1.title': 'Pilih Senarai Soalan',
  'pages.sideBySide.tour.step2.description':
    'Masukkan khalayak sasaran atau nama klien, kemudian pilih dokumen yang anda mahu bandingkan secara bersebelahan.',
  'pages.sideBySide.tour.step2.title': 'Isi Khalayak Sasaran dan Pilih Fail',
  'pages.sideBySide.tour.step3.description':
    'Semak gesaan sistem dan senarai soalan di sini. Beralih ke panel sejarah untuk melihat sesi terdahulu.',
  'pages.sideBySide.tour.step3.title': 'Lihat Gesaan Sistem dan Soalan',
  'pages.sideBySide.tour.step4.description':
    'Setelah anda menghantar, keputusan bersebelahan akan dipaparkan dalam jadual. Klik sel untuk melihat butiran.',
  'pages.sideBySide.tour.step4.title': 'Lihat Keputusan Bersebelahan',
  'pages.sideBySide.typeHerePlaceholder': 'Taip di sini...',
  'pages.sideBySide.undoChangesButton': 'Batalkan Perubahan',
  'pages.sideBySide.unsavedChangesWillBeLost':
    'Sebarang perubahan yang belum disimpan akan hilang.',
  'pages.sideBySide.untitled': '(Tanpa Tajuk)',
  'pages.sideBySide.updateCellFailed': 'Gagal mengemas kini sel',
  'pages.sideBySide.updateCellVerificationFailed': 'Gagal mengemas kini pengesahan sel',
  'pages.sideBySide.updateFailed': 'Gagal mengemas kini',
  'pages.sideBySide.uploadDocumentFailed': 'Gagal memuat naik dokumen',
  'pages.sideBySide.whatsNewDescription':
    'Beberapa ciri baharu diperkenalkan untuk mempertingkat proses perbandingan dokumen bersebelahan anda.',
  'pages.sideBySide.whoIsItForQuestion': '1. Untuk siapa ia?',
};
